export function getHostname() {
  return window.location.origin;
}
